import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { b as DELETE_USER, U as UPDATE_USER, c as CREATE_USER, d as GET_USERS } from './types-0b7e03a3.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var initialState = {
  users: [],
  currentUser: {},
  ok: true,
  message: '',
  errors: []
};
function userReducer () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case GET_USERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        message: action.payload.message,
        errors: action.payload.errors,
        users: action.payload.users
      });

    case CREATE_USER:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        message: action.payload.message,
        errors: action.payload.errors,
        currentUser: action.payload.user
      });

    case UPDATE_USER:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        message: action.payload.message,
        errors: action.payload.errors,
        currentUser: action.payload.user
      });

    case DELETE_USER:
      return _objectSpread(_objectSpread({}, state), {}, {
        ok: action.payload.ok,
        message: action.payload.message,
        errors: action.payload.errors,
        currentUser: action.payload.user
      });

    default:
      return state;
  }
}

export { userReducer as default };
